import React from 'react';
import { useParams } from 'react-router';

export default function useNumberParams(name) {
  const param = useParams();
  return +param[name];
}
